import axios from "axios";

//state
export var pageState = {
  pages: [],
  facebook_pages: [],
  status_page: ""
};

//getters
export var pageGetters = {
  //funciones para optener informacion del state
  getPages: state => state.pages,
  getFacebookPages: state => state.facebook_pages
};

//actions
export var pageActions = {
  async getPages({ commit,state }) {
    var access_token = state.api_token_facebook
    commit("page_request");
    await axios
      .get(`https://graph.facebook.com/v4.0/113799016686825/accounts`, {
        params: {
          access_token
        }
      })
      .then(res => {
        const pages = res.data.data;
        commit("page_success", pages);
        return pages;
      })
      .catch(err => {
        commit("page_error");
        return err;
      });
  },
  async getFacebookPages({ commit }) {
    commit("page_request");
    await this._vm.$http
      .get("/apache/rest_api/apache.page", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields: '["name", "page_id", "create_date","id"]',
          limit: "80"
        }
      })
      .then(res => {
        const pages = res.data;
        commit("facebook_page_success", pages);
        return res;
      })
      .catch(err => {
        commit("page_error");
        return err;
      });
  },
  async newPage({ commit, state }, page) {
    commit("page_request");
    var {
      name,
      category,
      page_id,
      user_account_id
    } = page;
    var formData = new FormData();
    var newPage = `{
      'name':'${name}',
      'category':'${category}',
      'page_id': '${page_id}',
      'user_account_id': '${user_account_id}',
      'relational_fields': [('user_account_id', 'apache.user.account')
                          ]
      }`;
    formData.append("data", newPage);
    await this._vm.$http
      .post("/apache/rest_api/apache.page", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1",
        }
      })
      .then(res => {
        if (res.status == 201) {
          page.id = res.data.id;
          var pages = state.facebook_pages;
          pages.push(page);
          commit("facebook_page_success", pages);
          return pages;
        } else {
          commit("page_error");
        }
      })
      .catch(err => {
        commit("page_error");
        return err;
      });
  },
  async editPage({ commit, state }, page) {
    commit("page_request");
    var {
      id,
      name,
      category,
      page_id,
      user_account_id
    } = page;
    var formData = new FormData();
    var newPage = `{
      'name':'${name}',
      'category':'${category}',
      'page_id': '${page_id}',
      'user_account_id': '${user_account_id}',
      'relational_fields': [('user_account_id', 'apache.user.account')
                          ]
      }`;
    formData.append("data", newPage);
    await this._vm.$http
      .put("/apache/rest_api/apache.page", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1",
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          var index;
          var pages = state.facebook_pages;
          for (var i = 0; i < pages.length; i++) {
            if (pages[i].id == id) {
              index = i;
              pages[i] = page;
              break;
            }
          }
          pages.splice(index, 1);
          pages.splice(index, 0, page);
          commit("facebook_page_success", pages);
          return pages;
        } else {
          commit("page_error");
        }
      })
      .catch(err => {
        commit("page_error");
        return err;
      });
  },
  async deletePage({ commit, state }, id) {
    commit("page_request");
    await axios
    .delete(`/apache/rest_api/apache.page/${id}`, { 
      headers: {
      "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 210) {
          var pages = []
          commit("facebook_page_success", partners);
          return pages;
        } else {
          commit("page_error");
        }
      })
      .catch(err => {
        commit("partner_error");
        return err;
      });
  },
  async deletePageUtility({ commit, state }, id) {
    commit("page_request");
    var index;
    var pages = state.facebook_pages;
    for (var i = 0; i < pages.length; i++) {
      if (pages[i].id == id) {
        index = i;
        break;
      }
    }
    pages.splice(index, 1);
    commit("facebook_page_success", pages);
    return pages;
  }
};

//mutations

export var pageMutations = {
  page_request(state) {
    state.status_page = "loading";
  },
  page_success(state, payload) {
    state.status_page = "success";
    state.pages = payload;
  },
  facebook_page_success(state, payload) {
    state.status_page = "success";
    state.facebook_pages = payload;
  },
  page_error(state) {
    state.status_page = "error";
  }
};
